import { Autocomplete, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { getTiposCobertura } from '../../services/Busquedas/TiposCoberturas';

export const PEDIDO_INTERNACION = {
  descripcion: 'Pedido de Pre-Autorización de Internación o Prótesis',
  codigo: '262',
};

export const PEDIDO_AMBULATORIO = {
  descripcion: 'Prácticas ambulatorias médicas y bioquímicas',
  codigo: '166',
};

export const DENUNCIA_AFILIADO = {
  descripcion: 'Denuncia de afiliado',
  codigo: '265',
};

export const TipoCoberturaSelector = ({ label, value, onChangeOption, error }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const optionList = async () => {
      const fetchedOptions = await getTiposCobertura();
      setOptions(fetchedOptions || []);
    };

    optionList();
  }, []);

  const handleChange = (newValue) => {
    if (onChangeOption) {
      onChangeOption(newValue);
    }
  };

  return (
    <Autocomplete
      disablePortal
      value={value || null}
      isOptionEqualToValue={(option, value) => option?.idTipoCobertura === value?.idTipoCobertura}
      getOptionLabel={(option) => `${option?.descripcion || ''}`}
      options={options}
      onChange={(_, newValue) => handleChange(newValue)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label || 'Tipo de cobertura'}
          variant='standard'
          error={!!error}
          helperText={error ? error.message : ''}
          InputProps={{
            ...params.InputProps,
            endAdornment: <>{params.InputProps.endAdornment}</>,
          }}
        />
      )}
    />
  );
};
